import { UseMutationResult } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { UseFormReturn } from "react-hook-form";

import { useTranslation } from "../../core/translation.core";
import useShop from "../../hooks/useShop.hook";
import { BrandFormData } from "../../types/brand";
import { LocalInputDefaultLocale } from "../locale/locale.comp";
import { EditorSection, SubmitPanel, Title } from "../reuseables/editor.comp";
import { LabelAndInput } from "../reuseables/form.comp";

export default function BrandEditor({
  methods,
  mutation,
  btnName,
}: {
  methods: UseFormReturn<BrandFormData, any>;
  mutation: UseMutationResult<void, unknown, BrandFormData, unknown>;
  btnName: string;
}) {
  const { t, msg } = useTranslation();
  const selectedShop = useShop();
  const { push } = useRouter();

  async function onSubmit(data: BrandFormData) {
    mutation.mutate(data);
  }

  if (!selectedShop) return null;

  return (
    <form onSubmit={methods.handleSubmit(onSubmit)} className="pb-20">
      <EditorSection>
        <Title>{t(msg.product.generalInfo)}</Title>
        <div className="text-xs flex flex-col gap-4">
          <LabelAndInput register={methods.register} fieldName="code" label={t(msg.category.code)} topLabelCss="block" />
          <LocalInputDefaultLocale register={methods.register} label={t(msg.brand.name)} fieldName="name" />
        </div>
      </EditorSection>
      <SubmitPanel>
        <button onClick={() => push("/products")}>{t(msg.form.cancel)}</button>
        <input type="submit" value={btnName} />
      </SubmitPanel>
    </form>
  );
}
